<script>
  import Sections from "../../../components/layout/Sections.svelte";
  import Subsection from "../../../components/layout/Subsection.svelte";
  import SubsectionTitle from "../../../components/layout/SubsectionTitle.svelte";
  import { translate } from "../../../i18n/i18next.js";

  export let licenseData
</script>


<Sections>
  <Subsection>
    <SubsectionTitle>{translate("generic.username")}: {licenseData.username ?? "-"}</SubsectionTitle>
  </Subsection>
  <Subsection>
    <SubsectionTitle>
      モジュールタイプ: WS
    </SubsectionTitle>
  </Subsection>
  {#if licenseData.type}
    <Subsection>
      <SubsectionTitle>
        {translate("generic.license.type")}:
        {licenseData.type}
      </SubsectionTitle>
    </Subsection>
  {/if}
  {#if licenseData.validityPeriod}
    <Subsection>
      <SubsectionTitle>
        {translate("frontend:pages.admin.server.sections.license.validityPeriod.title", null, {start: licenseData.validityPeriod.start, end: licenseData.validityPeriod.end})}
      </SubsectionTitle>
    </Subsection>
  {/if}
  <Subsection>
    <SubsectionTitle>
      利用可能なサブライセンス: {licenseData.subLicenses.map(subLicense => `${subLicense.moduleType} (使用可能品番数: ${subLicense.dataUsage})`)}
    </SubsectionTitle>
  </Subsection>
  <Subsection>
    <SubsectionTitle>
      <div style="display: flex; gap: 2rem">
        <div>
          {translate("frontend:pages.admin.server.sections.license.authenticationMethod.title")}:
          {#if licenseData.authMethod === "eProtector"}
            {translate("generic.license.protectors.eProtector")}
          {/if}
          {#if licenseData.authMethod === "invalidEProtector"}
            {translate("generic.license.protectors.eProtector")} ({translate("generic.invalid")})
          {/if}
          {#if licenseData.authMethod === "online"}
            {translate("generic.license.protectors.online")}
          {/if}
          {#if licenseData.authMethod === "none"}
            {translate("generic.license.protectors.none")}
          {/if}
          {#if licenseData.authMethod === "dev"}
            dev
          {/if}
        </div>
      </div>
    </SubsectionTitle>
  </Subsection>
</Sections>
